/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
// import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import { Button } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import ClassNames from 'classnames';

const { selectCountryValidations, getVariantConfig } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectProductEntities } = Slices.productSlice;
const { addProductToCustomize, increaseQtyByN } = Slices.tempCartSlice;
const { selectDesktop } = Slices.appSlice;
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';

import enabledCartBag from './images/cartBag.svg';
import disabledCartBag from './images/disabledCartBag.svg';
import noImg from '../../assets/no-itm.png';
import { useLocation } from '@reach/router';

export default function AddToCart({
  addtoCart,
  productId,
  stepId,
  setCurrentStepperId,
  isAddToCartEnabled,
  availableStepCount,
  setShowBundleGroupDialog,
  category,
  title,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const intl = useIntl();

  const isDesktop = useSelector(selectDesktop);
  const variationConfig = useSelector(getVariantConfig);
  const tempCart = useSelector((state) => state.tempCart);
  const cart = useSelector((state) => state.cart);
  const productsMap = useSelector(selectProductEntities);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  const locationSearch = new URLSearchParams(location.search);

  let currentProduct = productsMap[productId];
  if (locationSearch.has('option')) {
    currentProduct =
      productsMap[productId]?.items?.find(
        (item) =>
          item?.id == locationSearch.get('option') ||
          item?.sel1Value == locationSearch.get('option')
      ) || currentProduct;
  }

  let productCustomization = tempCart.data.items.find((product) => product.id == productId);

  const handleReset = () => {
    if (!Array.isArray(currentProduct?.steps) || currentProduct?.steps?.length == 0) {
      currentProduct = productsMap[currentProduct?.id || currentProduct];
      if (currentProduct?.bundleTypeId == 'bundle_group') {
        currentProduct = currentProduct?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return (
            itemInfo?.id == locationSearch.get('option') ||
            itemInfo?.sel1Value == locationSearch.get('option')
          );
        });

        if (!currentProduct?.id) {
          currentProduct = productsMap[currentProduct];
        }
      }
    }
    const initialStep = currentProduct?.steps?.filter((step) => !step?.isHidden)?.[0]?.id || 1;
    let selectedBundleId;
    if (productsMap[productId]?.bundleTypeId == 'bundle_group') {
      let currentVariant = productsMap[productId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return (
          itemInfo?.id == locationSearch.get('option') ||
          itemInfo?.sel1Value == locationSearch.get('option')
        );
      });
      if (!currentVariant?.id) {
        currentVariant = productsMap[currentVariant];
      }

      selectedBundleId = currentVariant?.id;
    }

    const data = {
      ...currentProduct,
      id: productId,
      category: currentProduct?.categories?.[0] || category?.id,
      noIncrement: true,
    };

    if (selectedBundleId) {
      data['selectedBundleId'] = selectedBundleId;
    }

    dispatch(
      addProductToCustomize({
        productType: productsMap[productId].bundleTypeId,
        updatedOn: new Date().getTime(),
        mainProductId: productsMap[productId],
        data: data,
      })
    );

    if (locationSearch.has('cartId')) {
      let cartItem = cart.data.items[locationSearch.get('cartId')];
      let qty = cartItem?.qty;
      dispatch(
        increaseQtyByN({
          data: {
            id: data?.id,
            qty: qty,
          },
        })
      );
    }

    console.log(`5 setting - `, initialStep);
    setCurrentStepperId((prev) => initialStep);
    console.log(`6 unlockedStepperId - `, initialStep);
    window.localStorage.setItem('unlockedStepperId', initialStep);
  };

  // find prices
  let bundleGroupPrice = 0;
  const addedProducts = Object.values(productCustomization?.bundle || {});
  addedProducts.forEach((addedProduct) => {
    let addedProductId = Object.keys(addedProduct || {})[0];
    let addedProductVariants = Object.values(addedProduct || {})[0]?.variants;

    // find variation
    let currentProductVariation;
    let variationArray = [-1, -1, -1];

    if (addedProduct?.variants) {
      Object.values(addedProduct?.variants || {}).forEach((variant, index) => {
        variationArray[index] = variant;
      });
    } else {
      let defaultVariationArray = [-1, -1, -1];
      for (let variation of currentProduct?.steps[0]?.options?.find(
        (option) => option?.id == addedProductId
      )?.variants || []) {
        const selectedOption = variation?.options?.find((option) => option?.isSelected == 1)?.id;
        defaultVariationArray[variation?.selIndex - 1] = selectedOption;
      }
      variationArray = defaultVariationArray;
    }

    currentProductVariation = currentProduct?.steps[0]?.options
      ?.find((item) => item.id == addedProductId)
      ?.items?.find((item) => {
        let isVariantSame = true;
        variationArray.forEach((variant, index) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }
          if (itemInfo[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

    currentProductVariation = currentProductVariation?.id
      ? currentProductVariation
      : productsMap[currentProductVariation];

    // price calculation
    let finalPrice =
      currentProductVariation?.specialPrice || currentProductVariation?.originalPrice || 0;

    for (let step of currentProductVariation?.steps || []) {
      for (let option of step?.options || []) {
        if (option?.subOptions) {
          finalPrice +=
            option?.subOptions[addedProduct?.items?.[step.id]?.[option.id]?.['qty'] - 1]?.price ||
            0;
        } else {
          if (addedProduct?.items?.[step.id]?.[option.id]?.['qty']) {
            finalPrice +=
              (option?.price || 0) *
              Number(addedProduct?.items?.[step.id]?.[option.id]?.['qty'] || 0);
          }
        }
      }
    }

    if (currentProduct?.isBOGO) {
      bundleGroupPrice = Math.max(bundleGroupPrice, finalPrice);
    } else {
      bundleGroupPrice += finalPrice;
    }
  });

  const handleVariantChange = () => {
    setShowBundleGroupDialog(productId);
  };

  const AddToCartButton = () => (
    <div
      className={ClassNames(css.checkoutSection, { [css.disabledButton]: !isAddToCartEnabled })}
      onClick={addtoCart}
    >
      <div className={css.cartAmount}>
        {isAddToCartEnabled && (
          <div className={css.cartImg}>
            <img
              src={currentProduct.assets[0].src}
              alt=""
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImg;
              }}
            />
          </div>
        )}
        <div className={css.itemDetail}>
          {isAddToCartEnabled && <h4>1 ITEM</h4>}
          <h5>
            <span>
            <span>
              {decimalChecker(
                (productCustomization?.price ||
                  currentProduct?.specialPrice ||
                  currentProduct?.originalPrice ||
                  bundleGroupPrice) / (productCustomization?.qty || 1)
              )}
            </span>
            <span>{currentProduct.currency}</span>
            </span>
            {isAddToCartEnabled && (
              <span className={css.taxInclusiv}>
                {intl.formatMessage({ id: 'inclusive_of_taxes' })}
              </span>
            )}
          </h5>
        </div>
        {/* {countryValidations?.isVatEnabled ? (
          <p>
            <FormattedMessage id="VAT_Text" defaultMessage="*All prices are VAT Exclusive" />
          </p>
        ) : (
          ''
        )} */}
      </div>
      <div className={css.checkoutButton}>
        <img src={isAddToCartEnabled ? enabledCartBag : disabledCartBag} alt="Cart bag" />
        <span className={css.label}>
          {locationSearch.has('cartId') ? (
            <FormattedMessage id="update_cart" defaultMessage="Update Cart" />
          ) : (
            <FormattedMessage id="product_addtocart" defaultMessage="Add to cart" />
          )}
        </span>
      </div>
    </div>
  );

  let currentVariantInfo = productsMap[productId]?.items?.find((item) => {
    let itemInfo;
    if (!item?.id) {
      itemInfo = productsMap[item];
    } else {
      itemInfo = item;
    }

    return (
      itemInfo?.id == locationSearch.get('option') ||
      itemInfo?.sel1Value == locationSearch.get('option')
    );
  });

  if (!currentVariantInfo?.id) {
    currentVariantInfo = productsMap[currentVariantInfo];
  }

  let variation = variationConfig?.[0]?.variations.filter((v) =>
    title.includes(v[`key_${intl.locale}`])
  );
  if (variation?.length) variation = variation[0];

  const subtitle = variation?.[`subtitle_${intl.locale}`] || '';

  const currentVariantPrice =
    currentVariantInfo?.specialPrice ||
    currentVariantInfo?.originalPrice ||
    currentVariantInfo?.price ||
    0;

  let currentVariationInfo = productsMap[productId]?.variants?.[0]?.options.find(
    (option) => option?.id == locationSearch.get('option')
  );

  return (
    <div className={css.addToCartContainer}>
      <img
        className={css.productImg}
        src={currentProduct?.assets[0]?.src}
        alt={title || 'product'}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImg;
        }}
      />
      <div className={css.productDesc}>
        <div className={css.productInfoDesc}>
          <div className={css.productNameTitle}>
            <div className={css.productName}>{currentProduct?.name}</div>
            <Button
              size={intl.locale == 'en' ? 'small' : 'large'}
              variant="outlined"
              onClick={handleReset}
            >
              <FormattedMessage id={'customize_reset'} defaultMessage={'customize_reset'} />
            </Button>
          </div>
          <div className={css.productDescText}>{currentProduct?.description}</div>
        </div>
      </div>
      {isDesktop && locationSearch.has('bundleGroup') && (
        <div className={css.dealSizeSelector}>
          <div className={css.currentVariantInfo}>
            <div className={css.column1}>
              <img
                className={css.currentVariationImg}
                src={currentVariantInfo?.assets?.[0]?.src}
                alt={`${currentVariantInfo?.assets?.[0]?.assets}`}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImg;
                }}
              />

              <div className={css.currentVariationDetails}>
                <p className={css.variationName}>
                  <span>{currentVariationInfo?.title}</span>
                  {subtitle && <span className={css.variationSubtitle}>{`(${subtitle})`}</span>}
                </p>
                {currentVariantPrice > 0 && (
                  <p className={css.variationPrice}>
                    <span className={css.price}>{decimalChecker(currentVariantPrice)}</span>
                    {` `}
                    <span className={css.currency}>{countryValidations.currency}</span>
                  </p>
                )}
              </div>
            </div>
            <div className={css.column2} onClick={() => handleVariantChange()}>
              <span className={css.changeBtn}>
                {intl.formatMessage({ id: 'navigation_change' })}
              </span>
            </div>
          </div>
        </div>
      )}
      <AddToCartButton />
    </div>
  );
}
